export default __webpack_public_path__ + "static/media/DroppointDisplayDiagram.4d406ffb.png";